/**
 * What the arrow keys, the return key and the escape key do to an open list.
 *
 * A module of its own because it is the half of the box that never asks the
 * route anything. `./search-suggestions.ts` is the asking and this is the
 * steering, and the two meet on one `keydown` listener.
 */

import type { SuggestionList } from "./suggestion-list.js";

/** The arrows, the return key and the escape key, while a list is open. */
export function steerList(properties: {
  /** The press, whose default action some of these keys refuse. */
  readonly event: KeyboardEvent;

  /** The list the keys move through. */
  readonly list: SuggestionList;

  /** The box, which a chosen word is put back into. */
  readonly input: HTMLInputElement;
}): void {
  const { event, list, input } = properties;
  const chosen = list.chosen;

  if (event.key === "Escape" && list.isOpen) {
    event.preventDefault();
    list.hide();
  } else if (!list.isOpen) {
    return;
  } else if (event.key === "ArrowDown" || event.key === "ArrowUp") {
    // Refused because both keys move the caret in a text field otherwise,
    // and a reader arrowing through a list is not editing what they typed.
    event.preventDefault();
    list.move(event.key === "ArrowDown" ? 1 : -1);
  } else if (event.key === "Enter" && chosen !== undefined) {
    // The default action is the form's own submission, and that is what
    // should happen. The word goes in the box first and the browser sends it.
    input.value = chosen;
    list.hide();
  } else if (event.key === "Tab") {
    list.hide();
  }
}
